export const uk = {
    canNotBeEmpty: 'Значение не может быть пустым',
    emptyRegions: 'Регионы не выбраны',
    finishTimeShouldBeGreaterThanStartTime:
        'Дата и время окончания показов не могут быть меньше или равны дате и времени начала показов',
    incorrectVersion:
        'Неправильно указана версия. Укажите целое число или десятичную дробь. В качестве десятичного разделителя используйте точку. Пример: 6.14',
    invalidDate: 'Неправильная дата',
    invalidUrl: 'Неправильный URL мобильного приложения',
    invalidValue: 'Неправильное значение',
    invalidYandexUid: 'Неправильный YandexUid. Введите числовое значение длиной от 17 до 19 символов или маску',
    multipleVersions: 'Таргетинг может иметь только один элемент с указанием версий',
    numericInvalidValue: 'Введённое значение не является числом',
    numericNegativeValue: 'Введённое значение меньше нуля',
    suggestInvalidValue: 'Неизвестное значение. Выберите значение из списка',
    unknownError: 'Неизвестная ошибка',
    valueShouldBeLessThan: 'Введённое значение должно быть меньше или равно {maxValue}',
    valueShouldBeMoreThan: 'Введённое значение должно быть больше или равно {minValue}'
};
